import { useQuery, useMutation } from '@tanstack/react-query';
import restClient from '../common/api/restClient';

// Hook per cercare challenge definitions per topic
export const useSearchChallengeDefinitions = (topic, enabled = true) => {
  const prefix = process.env.REACT_APP_PROXY_PREFIX || '';
  return useQuery({
    queryKey: ['challenge-definitions', 'search', topic],
    queryFn: async () => {
      const result = await restClient({
        url: `${prefix}/challenge-definitions/search`,
        method: 'POST',
        data: { topic }
      });
      return result;
    },
    enabled: enabled && !!topic, // Solo se enabled è true e topic non è vuoto
    staleTime: 0,
    cacheTime: 0
  });
};

// Hook per aggiornare i sort numbers
export const useUpdateSortNumbers = () => {
  const prefix = process.env.REACT_APP_PROXY_PREFIX || '';
  return useMutation({
    mutationFn: async (challengeOrder) => {
      const result = await restClient({
        url: `${prefix}/challenge-definitions/update/sort-numbers`,
        method: 'PUT',
        data: { challengeOrder }
      });
      return result;
    }
  });
};
